import React, { useEffect, useRef } from "react";
import { Row } from "react-bootstrap";
import { certificationsArray } from "./CertificationsArray";
import CertificationsCard from "./CertificationsCard";
import { useMediaQuery } from "react-responsive";
import { motion } from "motion/react";

const Certifications = (props) => {
  const myRef = useRef(null);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  useEffect(() => {
    if (props.sd === "certifications") {
      console.log(props.sd);
      myRef.current.scrollIntoView();
    }
  }, [props.sd]);

  return (
    <div
      ref={myRef}
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1
        style={{
          color: "black",
          fontSize: isTabletOrMobile ? "40px" : "50px",
          fontWeight: "bold",
          color: "#155BDD",
          marginTop: "50px",
          fontFamily: "Tenorite",
        }}
      >
        CERTIFICATIONS
      </h1>
      <br />
      <Row
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-around",
          marginBottom: "20px",
          marginTop: "20px",
          flexWrap: "wrap",
        }}
      >
        {certificationsArray.map((certification) => (
          <motion.div
            style={{
              width: "fit-content"
            }}
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
          >
            <CertificationsCard
              certid={certification.id}
              name={certification.certificationName}
              certificationThumbnail={certification.certificationThumbnail}
              certificationDescription={certification.certificationDescription}
              certificationUrl={certification.certificationURL}
            />
          </motion.div>
        ))}
      </Row>
    </div>
  );
};

export default Certifications;
